"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const effects_1 = require("redux-saga/effects");
const saga_1 = __importDefault(require("./widgets/behavior/saga"));
const sagas_1 = require("./widgets/content/sagas");
const saga_2 = __importDefault(require("./catalogMeta/saga"));
const saga_3 = __importDefault(require("./catalog/saga"));
const saga_4 = __importDefault(require("./authentication/saga"));
const saga_5 = __importDefault(require("./quote/saga"));
const saga_6 = __importDefault(require("./project/saga"));
const saga_7 = __importDefault(require("./data/saga"));
const saga_8 = __importDefault(require("./user/saga"));
const saga_9 = __importDefault(require("./account/saga"));
const saga_10 = __importDefault(require("./address/saga"));
const saga_11 = __importDefault(require("./customerManagement/saga"));
function* root() {
    yield (0, effects_1.all)([
        (0, saga_4.default)(),
        (0, saga_6.default)(),
        (0, saga_8.default)(),
        (0, saga_2.default)(),
        (0, saga_3.default)(),
        (0, sagas_1.catalogWidget)(),
        (0, saga_1.default)(),
        (0, sagas_1.bom)(),
        (0, sagas_1.recommendedFasteners)(),
        (0, saga_5.default)(),
        (0, saga_7.default)(),
        (0, saga_9.default)(),
        (0, saga_10.default)(),
        (0, saga_11.default)(),
    ]);
}
exports.default = root;
